import { teal } from '../teal';

export const low = {
  primary: teal[200],
  500: teal[500],
  400: 'hsla(28, 13%, 74%, 1)',
  300: 'hsla(28, 13%, 80%, 1)',
  200: 'hsla(28, 13%, 86%, 1)',
  100: teal[100],
  50: teal[50],
  30: 'hsla(28, 13%, 94%, 0.5)',
};
